module.exports = __webpack_public_path__ + "img/hylei-2.38284fba.png";